import { FC } from "react";
import { Box, Grid, Paper, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { formatNumber } from "../../../../../../common/utils";
import { CarbonSnapResultsResponse } from "../../../../../../datasources/carbonsnap/io/response";

interface Props {
	totalEmissions: CarbonSnapResultsResponse["totalEmissions"];
}

const ResultsKPISection: FC<Props> = ({ totalEmissions }) => {
	const { t } = useTranslation("whatIf.carbonsnap");

	return (
		<Box>
			<Typography variant="h6" sx={{ mb: 2 }}>
				{t("results/kpi/title")}
			</Typography>
			<Paper sx={{ p: 3 }}>
				<Grid container spacing={2}>
				<Grid size={{ xs: 12, md: 3 }}>
					<Typography variant="body2" color="text.secondary">
						{t("results/kpi/transport emissions")}
					</Typography>
					<Typography variant="h6">
						{formatNumber(totalEmissions.transportEmissions.value, "decimal", 0, 2)} {totalEmissions.transportEmissions.measure}
					</Typography>
				</Grid>
				<Grid size={{ xs: 12, md: 3 }}>
					<Typography variant="body2" color="text.secondary">
						{t("results/kpi/hub emissions")}
					</Typography>
					<Typography variant="h6">
						{formatNumber(totalEmissions.hubEmissions.value, "decimal", 0, 2)} {totalEmissions.hubEmissions.measure}
					</Typography>
				</Grid>
				<Grid size={{ xs: 12, md: 3 }}>
					<Typography variant="body2" color="text.secondary">
						{t("results/kpi/emission intensity")}
					</Typography>
					<Typography variant="h6">
						{formatNumber(totalEmissions.emissionIntensity.value, "decimal", 0, 2)} {totalEmissions.emissionIntensity.measure}
					</Typography>
				</Grid>
				<Grid size={{ xs: 12, md: 3 }}>
					<Typography variant="body2" color="text.secondary">
						{t("results/kpi/biogenic emissions")}
					</Typography>
					<Typography variant="h6">
						{formatNumber(totalEmissions.biogenicEmissions.value, "decimal", 0, 2)} {totalEmissions.biogenicEmissions.measure}
					</Typography>
				</Grid>
				</Grid>
			</Paper>
		</Box>
	);
};

export default ResultsKPISection;
